/*eslint-disable*/
import React from "react";
import IndexNavbar from "components/Navbars/EcommerceNavbar.js";

import HeroBannerSerec from "components/Body/HeroBannerSerec";
import HeroBanner from "components/Body/HeroBanner";
import { getMyAccountId } from "utils/config";

export default function Index() {
  const MYACCOUNT_ID = getMyAccountId();
  return (
    <>
      <IndexNavbar fixed />
      <main className="pt-20">
        {/* Banner */}
        {MYACCOUNT_ID === 5035 ? <HeroBannerSerec /> : <HeroBanner />}

      </main>
    </>
  );
}
